import axiosInstance from "./AxiosInstance";

//service-type

export function getServiceListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`/api/service-types?${fparam}`)
}

export function createServiceApi(data){
    return axiosInstance.post('/api/service-types',data)
}
export function updateServiceApi(id,data){
    return axiosInstance.put(`/api/service-types/${id}`,data)
}
export function deleteServiceApi(id){
    return axiosInstance.delete(`/api/service-types/${id}`)
}
//service-center

export function getServiceCenterCashDetailsApi(id){
    return axiosInstance.get(`api/service-centers-cash-summary/${id}`)
}
export function getServiceCenterListApi(param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`/api/service-centers?${fparam}`)
}

export function createServiceCenterApi(data){
    return axiosInstance.post('/api/service-centers',data)
}

export function editServiceCenterApi(id,data){
    return axiosInstance.patch(`/api/service-centers/${id}`,data)
}

export function getServiceCenterDetailsApi(id){
    return axiosInstance.get(`/api/service-centers/${id}`)
}

export function getServiceCenterBillingApi(id,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`/api/billing-by-service-center/${id}?${fparam}`)
}

export function getServiceCenterUserApi(id,param){
    const fparam=new URLSearchParams(param).toString()
    return axiosInstance.get(`/api/users-by-service-center/${id}?${fparam}`)
}

export function getTodayBillReportByServiceCenter(id){
    return axiosInstance.get(`/api/todays-billing-summary/${id}`)
}
export function getServiceCenterBillingExportApi(id,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/billing-by-service-center/${id}?${fparam}`, {
    responseType: "blob",
  });
}
export function getServiceCenterUsersExportApi(id,param) {
  const fparam = new URLSearchParams(param).toString();
  return axiosInstance.get(`/api/users-by-service-center/${id}?${fparam}`, {
    responseType: "blob",
  });
}